module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("为什么使用 .vue 源码分发而不是 js 文件")]), _vm._v(" "), _c('p', [_vm._v("代码冗余，无法在构建时优化，出错时难以跟踪，作为组件维护者可能要打包多份代码出来满足不同需求(压缩版，未压缩，不同语言版)。在webpack中如果不加配置还会被多次打包。")]), _vm._v(" "), _c('p', [_vm._v("整体打包成一个js和一个css在移动端属于严重浪费，降低体验和性能。")]), _vm._v(" "), _c('p', [_vm._v("就上面的问题来说，源码分发的方式完美解决。")]), _vm._v(" "), _c('p', [_vm._v("源码分发的最大好处是可以实现源码编译时处理，这也是 "), _c('code', [_vm._v("vux-loader")]), _vm._v(" 的用处。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-194a070e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-194a070e"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/why-use-vue-file-for-distribution-55.vue
// module id = 2060
// module chunks = 178